import React, { useState } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

interface AddHabitGridButtonProps {
  onAddClick: () => void;
}

const AddHabitGridButton: React.FC<AddHabitGridButtonProps> = ({ onAddClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    onAddClick();
  };

  return (
    <Box
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
    >
      <Tooltip title="Track a new habit" arrow>
        <IconButton
          onClick={handleClick}
          aria-label="Add Habit"
          sx={{
            width: 56,
            height: 56,
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            boxShadow: 2,
            opacity: isHovered ? 1 : 0,
            transform: isHovered ? 'scale(1)' : 'scale(0.8)',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            '&:hover': {
              bgcolor: 'primary.dark',
              transform: 'scale(1.1)',
              boxShadow: 8,
            },
          }}
        >
          <AddIcon sx={{ fontSize: 28 }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default AddHabitGridButton;
